export const environment = {
  VERSION: require('../../package.json').version,
  production: true,
  websocketUrl: 'https://a.latam.aware.blue:1344/',
  apiUrl: 'https://a.latam.aware.blue:1344/',
  apiKey: 'IDwsF4mHYL8wG7i31QaJH3cDGw8R9NZ31O0Jfw1e',
};
